module.exports = __webpack_public_path__ + "static/media/quick_service_layout.03bef054.svg";